import { render } from "./DefectsDetection.vue?vue&type=template&id=b9e4c37c&scoped=true"
import script from "./DefectsDetection.vue?vue&type=script&lang=js"
export * from "./DefectsDetection.vue?vue&type=script&lang=js"

import "./DefectsDetection.vue?vue&type=style&index=0&id=b9e4c37c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9e4c37c"]])

export default __exports__